<template>
  <div class="cxr-partner-logos d-flex flex-column align-items-center mx-auto">
    <p class="m-0">In partnership with</p>
    <div class="d-flex flex-row">
      <a v-for="({ img, alt, href }) in logos" :key="href" :href="href" target="_blank">
        <b-img fluid :alt="alt" :src="img"/>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    logos: () => ([
      {
        img: '/static/images/success/cxr-partner-logos/baxter.png',
        alt: 'Baxter',
        href: 'https://www.baxter.com/',
      },
      {
        img: '/static/images/success/cxr-partner-logos/cxr.png',
        alt: 'CareerXroads',
        href: 'https://cxr.works/',
      },
      {
        img: '/static/images/success/cxr-partner-logos/cxrfoundation.png',
        alt: 'CXR Foundation',
        href: 'https://cxr.foundation/',
      },
      {
        img: '/static/images/success/cxr-partner-logos/exaqueo.png',
        alt: 'Exaqueo',
        href: 'https://www.exaqueo.com/',
      },
      {
        img: '/static/images/success/cxr-partner-logos/liz.png',
        alt: 'Liz Gelb-O’Connor',
        href: 'https://www.linkedin.com/in/lizgelboconnor/',
      },
      {
        img: '/static/images/success/cxr-partner-logos/real-links.png',
        alt: 'Real Links - Employee Referrals',
        href: 'https://www.reallinks.io/',
      },
      {
        img: '/static/images/success/cxr-partner-logos/shaker.png',
        alt: 'Shaker Recruitment Marketing',
        href: 'https://shaker.com/',
      },
    ]),
  },
};
</script>

<style lang="scss">
.cxr-partner-logos {
  @media (min-width: 800px) {
    max-width: 800px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/success/cxr-partner-logos.vue